var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'v-img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }